import React from 'react';
import { insertBeforeIcon, insertAfterIcon, PathElement, RectElement } from '@chordbaker/design';

interface InsertSlotIconProps {
  /** Which side of the current slot the new one goes. */
  position: 'before' | 'after';
  size?: number;
  color?: string;
}

/** A slot outline with a plus on the side the new slot will be inserted. */
const InsertSlotIcon: React.FC<InsertSlotIconProps> = ({
  position,
  size,
  color = 'currentColor',
}) => {
  const icon = position === 'before' ? insertBeforeIcon : insertAfterIcon;
  const [slot, plus] = icon.elements as [RectElement, PathElement];
  const iconSize = size ?? icon.defaultSize;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={iconSize}
      height={iconSize}
      viewBox={icon.viewBox}
      fill={icon.fill}
      stroke={color}
      strokeWidth={icon.strokeWidth}
      strokeLinecap={icon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={icon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
    >
      <rect x={slot.x} y={slot.y} width={slot.width} height={slot.height} rx={slot.rx} />
      <path d={plus.d} />
    </svg>
  );
};

export default InsertSlotIcon;
